import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Link } from '../../shared/models/link.model';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private readonly router = inject(Router);
  private readonly title = inject(Title);

  public navigate(link: Link): Promise<void> {
    return this.router
      .navigate([link.url])
      .then(() => this.title.setTitle(link.title));
  }
}
